import {
  wrapper,
  tabHeader,
  tabItem,
  tabItemActive,
} from "./style";

const Tabs = ({ tabs = [], activeKey, onChange }) => {
  return (
    <div style={wrapper}>
      <div style={tabHeader}>
        {tabs.map((tab) => {
          const isActive = tab.key === activeKey;

          return (
            <div
              key={tab.key}
              onClick={() => onChange(tab.key)}
              style={{
                ...tabItem,
                ...(isActive ? tabItemActive : {}),
              }}
            >
              {tab.label}
            </div>
          );
        })}
      </div>

      <div>
        {tabs.find((t) => t.key === activeKey)?.content}
      </div>
    </div>
  );
};

export default Tabs;
